<template>
  <b-container fluid>
    <div class="row">
      <div class="col-lg-12">
        <h2 class="lz-home-heading">{{ title }}</h2>
      </div>
    </div>
    <div class="row" v-if="isAdmin && !loading">
      <div class="col-lg-12">
        <resource-toolbar
          v-model="editMode"
          :admin="isAdmin"
          :show-manage="false"
          add-label="Add Document / Form"
          @add="AddForm" />
      </div>
    </div>
    <div class="row" v-if="loading">
      <div class="col-lg-12">
        <b-skeleton-img no-aspect height="132px" class="mb-3"></b-skeleton-img>
        <b-skeleton-img no-aspect height="132px"></b-skeleton-img>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-lg-12">
        <content-component
          :rows="rows"
          :forms="canEdit ? forms : forms.filter((form) => form.show)"
          :isAdmin="canEdit"
          @edit="EditResource"
          @toggle="ToggleResource" />
      </div>
    </div>
    <resource-form-modal
      ref="resourceModal"
      tab="forms"
      :showRowField="true"
      @saved="ResourceSaved" />
  </b-container>
</template>

<script>
import Services from '../../../services/main.service.vue'
import contentComponent from './content-component.vue'
import resourceFormModal from '../resource-form-modal.vue'
import resourceToolbar from '../resource-toolbar.vue'

export default {
  name: 'HomeFormsModule',
  components: {
    contentComponent,
    resourceFormModal,
    resourceToolbar
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      editMode: false,
      rows: 0,
      forms: []
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.hasAdminPrivileges
    },
    canEdit() {
      return this.isAdmin && this.editMode
    }
  },
  mounted() {
    this.fetchResources()
  },
  methods: {
    async fetchResources() {
      try {
        this.loading = true
        const { status, data } = await Services.Home.GetHomeResources()
        if (status === 200) {
          const items = data?.content?.forms ?? []
          this.forms = items.map((item) => ({
            uid: item.uid,
            parentUid: null,
            title: item.title,
            row: item.meta?.row ?? 1,
            show: item.show !== false,
            sortOrder: item.sortOrder,
            meta: item.meta,
            link: item.link || undefined
          }))
          this.rows = this.forms.length
            ? Math.max(...this.forms.map((form) => form.row))
            : 0
        }
      } catch (error) {
        console.error(error.message)
        this.$toasted.error('Failed to load documents and forms, please try again later.').goAway(3500)
        this.forms = []
        this.rows = 0
      } finally {
        this.loading = false
      }
    },
    AddForm() {
      if (!this.canEdit) {
        return
      }
      this.$refs.resourceModal.Open(null, { parentUid: null })
    },
    EditResource(item) {
      if (!this.canEdit) {
        return
      }
      this.$refs.resourceModal.Open(item)
    },
    async ToggleResource(item) {
      if (!this.canEdit) {
        return
      }
      try {
        const { status, data } = await Services.Home.UpdateHomeResource(item.uid, {
          show: item.show === false
        })
        if (status === 200 && data?.success !== false) {
          this.fetchResources()
        } else {
          this.$toasted.error('Failed to update visibility, please try again later.').goAway(3500)
        }
      } catch (error) {
        console.error(error.message)
        this.$toasted.error('Failed to update visibility, please try again later.').goAway(3500)
      }
    },
    ResourceSaved() {
      this.fetchResources()
    }
  }
}
</script>

<style scoped>
/* Shared home styling (toolbar, tabs, cards) lives in src/styles/logs.css. */
</style>
